import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";
import LicenseCodes from "../pages/LicenseCodes/LicenseCodes";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.License,
    key: "LicenseCodes",
  };

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={{}}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <LicenseCodes />
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};
